import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { updateMetaTags } from '@src/seo/meta';

/**
 * Updates page metadata and scroll position when the router changes screens.
 */
export function RouterChrome() {
  const { i18n } = useTranslation();
  const { pathname, search, hash } = useLocation();

  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    updateMetaTags(pathname);
  }, [pathname, i18n.language]);

  useEffect(() => {
    const switchingConversation =
      previousPath.current === pathname && /\/box\/[^/]+\/messenger\/?$/.test(pathname);
    previousPath.current = pathname;
    if (switchingConversation) return;
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, search, hash]);

  return null;
}
